import { Injectable } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';
import { FirestoreBase } from '../../core/db/firestore-base';
import { IncidenceUI } from './incidence.models';

@Injectable({ providedIn: 'root' })
export class IncidenceDbService extends FirestoreBase<IncidenceUI> {
  constructor(firestore: Firestore) {
    super('incidences', firestore);
  }
}
